import { css } from 'styled-components'

const fonts = css`
    @import url('https://fonts.googleapis.com/css?family=PT+Mono');
    @font-face {
        font-family: 'Interface';
        font-style: normal;
        font-weight: normal;
        src: url('https://s3.amazonaws.com/giphy-web-fonts/InterFace_W_Rg.woff2') format('woff2'),
            url('https://s3.amazonaws.com/giphy-web-fonts/InterFace_W_Rg.woff') format('woff');
    }
    @font-face {
        font-family: 'Interface';
        font-style: normal;
        font-weight: bold;
        src: url('https://s3.amazonaws.com/giphy-web-fonts/InterFace_W_Bd.woff2') format('woff2'),
            url('https://s3.amazonaws.com/giphy-web-fonts/InterFace_W_Bd.woff') format('woff');
    }
    @font-face {
        font-family: 'Interface';
        font-style: normal;
        font-weight: 900;
        src: url('https://s3.amazonaws.com/giphy-web-fonts/InterFace_W_XBd.woff') format('woff');
    }
    @font-face {
        font-family: 'Nexa Black';
        font-style: normal;
        font-weight: normal;
        src: url('https://s3.amazonaws.com/giphy-web-fonts/nexa_black-webfont.woff2') format('woff2'),
            url('https://s3.amazonaws.com/giphy-web-fonts/nexa_black-webfont.woff') format('woff');
    }
`

export default fonts
